import { render, staticRenderFns } from "./moreset.vue?vue&type=template&id=64e048cf&scoped=true"
import script from "./moreset.vue?vue&type=script&lang=js"
export * from "./moreset.vue?vue&type=script&lang=js"
import style0 from "./moreset.vue?vue&type=style&index=0&id=64e048cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e048cf",
  null
  
)

export default component.exports